module.exports = __webpack_public_path__ + "img/profile-active.44ff22b7.svg";